"use client";

import React, { useState } from "react";
import { RosetteForm } from "@/components/form/themed/RosetteForm.js";
import { SubmitButton } from "@/components/form/SubmitButton.js";
import Link from "next/link";
import { FormMessage } from "@rosette/web_components/src/ui/FormMessage.js";
import { Label } from "@rosette/web_components/src/ui/Label.js";
import { TextInput } from "@rosette/web_components/src/ui/TextInput.js";


export function ForgotPasswordForm() {
    const [email, setEmail] = useState("");
    const [confirmedEmail, setConfirmedEmail] = useState("");

    const confirmEmailError = (email === confirmedEmail ? null : "Emails do not match");

    return (
        <RosetteForm
            title="Recover your account on RoyalUr.net"
            action="/recover/submit"
            validationError={confirmEmailError}
            backPieces={[{ label: "Home", href: "/" }]}>

            <Label htmlFor="email">Email</Label>
            <TextInput
                type="email"
                id="email"
                name="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                required={true} />

            <Label htmlFor="confirm_email">Confirm Email</Label>
            <TextInput
                type="email"
                id="confirm_email"
                value={confirmedEmail}
                onChange={e => setConfirmedEmail(e.target.value)}
                required={true} />

            <FormMessage kind="error">
                {confirmedEmail.length === 0 && email.length > 0 ? "" : confirmEmailError}
            </FormMessage>

            <SubmitButton tone="rosette" />

            <p>
                Remember your password?
                {" "}
                <Link href="/login">
                    Sign in.
                </Link>
            </p>
        </RosetteForm>
    );
}
